import { view } from "@spawn/core";
import { LineWinView as Base } from "@spawn/slot-machine";
import Victor from "victor";

@view
export class LineWinView extends Base {
	protected override getWinTextPosition(paylineId: string): Victor {
		// Make sure text is centered.
		// See: https://gamomat.atlassian.net/browse/FTSS-134
		return super.getWinTextPosition(paylineId).subtractScalarX(25);
	}
}
